import React, { useEffect, useState } from "react";
import styles from "../GeneralInformation/GeneralInformation.module.scss";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { useAppSelector } from "../../../redux/hooks";
import Icon from "../../common/Icon/Icon";
import { useTranslation } from "react-i18next";
import { useProfileParams } from "../../../utils/common";
import { useCreateBusinessApproachMutation, useGetBusinessApproachDataQuery } from "../../../redux/services/leaderProfileBusinessApproachAPI";
import isEmpty from "lodash/isEmpty";
import { isValidResponse } from "../../../utils/validateAPIResponse";
import Editor from "../../common/Editor/Editor";


const BusinessApproach = () => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const [isEditing, setIsEditing] = useState(false);
  const [businessApproachData, setBusinessApproachData] = useState({
      completionRate: 0,
      programDetail: "",
      techniqueDetail: "",
      onboardingDetail: ""
    });
    const { affiliateCode, aboNumber } = useProfileParams();
    
    const {
      data: businessApproachResponseData,
      isFetching: isLoadingGetBusinessApproach,
      isError: isFetchBusinessApproachError,
    } = useGetBusinessApproachDataQuery(
      {
        affiliateCode,
        aboNumber,
      },
      { refetchOnMountOrArgChange: true}
    );
  
    const [
      createBusinessApproach,
      {
        isLoading: isLoadingCreateBusinessApproach,
        isError: isCreateBusinessApproachError,
      }] = useCreateBusinessApproachMutation();

  useEffect(() => {
    if(!isEmpty(businessApproachResponseData)) {
      if (isValidResponse(businessApproachResponseData?.statusCode)) {
        setBusinessApproachData(!isEmpty(businessApproachResponseData?.body) ? businessApproachResponseData?.body : {});
      }
    }
  },[businessApproachResponseData])

  const handleSave = () => {
    createBusinessApproach({
        affiliateCode,
        aboNumber,
        payload: businessApproachData
      }).then((resp: any) => {
        const businessApproachRestData = resp?.data?.body;
        if (!isEmpty(businessApproachRestData)) {
          setBusinessApproachData(businessApproachRestData);
        }
      })
    setIsEditing(false);
  };

  const handleCancel = () => {
    const existingData = businessApproachResponseData?.body
    setBusinessApproachData({
      completionRate: existingData?.completionRate,
      programDetail: existingData?.programDetail || "",
      techniqueDetail: existingData?.techniqueDetail || "",
      onboardingDetail: existingData?.onboardingDetail || "",
    })
    setIsEditing(false);
  };

  const handleChangeDesc = (keyName: string, value: string) => {
    setBusinessApproachData((prev) => ({ ...prev, [keyName]: value }));
  };

  return (
    <div className={styles.general_outer_wrapper}>
      <div className={styles.title_wrapper}>
        <div className={styles.title_inner}>
          <div className={styles.progress_bar}>
            <CircularProgressbarWithChildren
              value={businessApproachData?.completionRate}
              strokeWidth={20}
              className={styles["circular_progress_gradient"]}
              styles={buildStyles({
                trailColor: currentTheme === "light" ? "#D9D9D9" : "#282828",
              })}
            />
          </div>
          <div className={styles.general_info_title}>
            {t("business_approach")}
          </div>
        </div>
        <div className={styles.edit_icon_wrapper}>
          {isEditing ? (
            <>
              <span className={styles.cancel_text} onClick={handleCancel}>
                {t("btnCancel")}
              </span>
              <span className={styles.save_text} onClick={handleSave}>
                {t("btnSave")}
              </span>
            </>
          ) : (
            <div
              className={styles.edit_wrapper}
              onClick={() => setIsEditing(true)}
            >
              <Icon
                name="edit_goal_icon"
                size={14}
                color={currentTheme === "light" ? "#2C2C2C" : "#D8D8D9"}
                className={styles.search_icon}
              />
              <span className={styles.edit_text}>{t("edit")}</span>
            </div>
          )}
        </div>
      </div>

      <div className={`${styles.general_inner_wrapper} ${styles.two_col}`}>
      <div className={styles.first_column_wrapper}>
        <div className={styles.general_info}>
            <span className={styles.title}>{t("key_programs")}:</span>
            <Editor
              id="addProgramDetail"
              testId="addProgramDetailDesc"
              isEditing={isEditing}
              value={businessApproachData?.programDetail}
              onChange={(value) => handleChangeDesc("programDetail", value)}
              formatterBarPlaceholder={t("programs_initiatives")}
              section="program_detail"
              normalize={true}
              formatterBarWrapperClassName={styles.text_area_section}
              htmlToPdfContainerClassName={styles.description}
            />
        </div>
        <div className={styles.general_info}>
            <span className={styles.title}>{t("business_building_techniques")}:</span>
            <Editor
              id="addTechniqueDetail"
              testId="addTechniqueDetailDesc"
              isEditing={isEditing}
              value={businessApproachData?.techniqueDetail}
              onChange={(value) => handleChangeDesc("techniqueDetail", value)}
              formatterBarPlaceholder={t("business_techniques")}
              section="technique_detail"
              normalize={true}
              formatterBarWrapperClassName={styles.text_area_section}
              htmlToPdfContainerClassName={styles.description}
            />
        </div>
      </div>
      <div className={styles.second_column_wrapper}>
        <div className={styles.general_info}>
          <span className={styles.title}>{t("onboarding")}:</span>
          <Editor
            id="addOnboardingDetail"
            testId="addOnboardingDetailDesc"
            isEditing={isEditing}
            value={businessApproachData?.onboardingDetail}
            onChange={(value) => handleChangeDesc("onboardingDetail", value)}
            formatterBarPlaceholder={t("onboarding_details")}
            section="onboarding_detail"
            normalize={true}
            formatterBarWrapperClassName={styles.text_area_section}
            htmlToPdfContainerClassName={styles.description}
          />
        </div>
      </div>
    </div>
    </div>
  );
};

export default BusinessApproach;
